import LogRocket from 'logrocket';
export var logRocketMiddleware = LogRocket.reduxMiddleware();
